/**
 * @generated SignedSource<<7cbff902812cbb988b0aef940b64f768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signInUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isAnswerBase"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v8 = [
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldOptionChoice",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "values",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "other",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "formField",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v7/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hintPosition",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hide",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnly",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoComplete",
    "storageKey": null
  }
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v19/*: any*/),
          "type": "FormFieldString",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerString",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v19/*: any*/),
          "type": "FormFieldText",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerText",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentAttachmentToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displaySimilarContributionsSuggestions",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerRichText",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourcesAttachmentToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "multiple",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxFiles",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowedFileExtensions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumFileSize",
              "storageKey": null
            }
          ],
          "type": "FormFieldFile",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerFile",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherValue",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOtherField",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherFieldLabel",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleOptionSelection",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximumSelectableOptions",
  "storageKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v25/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/),
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selectableType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldOptionChoice",
              "kind": "LinkedField",
              "name": "listedOptions",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCorrect",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correctionText",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "optionsSearchable",
              "storageKey": null
            }
          ],
          "type": "FormFieldCheckBoxes",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldOptionChoice",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerCheckBoxes",
  "abstractKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerWeightedOption",
      "kind": "LinkedField",
      "name": "dispatchedBudgetValues",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionId",
          "storageKey": null
        },
        (v30/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budget",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxBudgetPerOption",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minBudgetToSpend",
              "storageKey": null
            },
            (v31/*: any*/)
          ],
          "type": "FormFieldBudgetDispatcher",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerBudgetDispatcher",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedThemeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumThemes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldThemeOption",
              "kind": "LinkedField",
              "name": "themes",
              "plural": true,
              "selections": [
                (v4/*: any*/),
                (v30/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormFieldThemeOption",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    (v30/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormFieldThemeOption",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": true,
                      "selections": [
                        (v4/*: any*/),
                        (v30/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormFieldThemeOption",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": true,
                          "selections": [
                            (v4/*: any*/),
                            (v30/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormFieldThemeOption",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                (v4/*: any*/),
                                (v30/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormFieldThemeOption",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    (v4/*: any*/),
                                    (v30/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "FormFieldThemeOption",
                                      "kind": "LinkedField",
                                      "name": "children",
                                      "plural": true,
                                      "selections": [
                                        (v4/*: any*/),
                                        (v30/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "FormFieldThemeOption",
                                          "kind": "LinkedField",
                                          "name": "children",
                                          "plural": true,
                                          "selections": [
                                            (v4/*: any*/),
                                            (v30/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FormFieldThemeOption",
                                              "kind": "LinkedField",
                                              "name": "children",
                                              "plural": true,
                                              "selections": [
                                                (v4/*: any*/),
                                                (v30/*: any*/),
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "FormFieldThemeOption",
                                                  "kind": "LinkedField",
                                                  "name": "children",
                                                  "plural": true,
                                                  "selections": [
                                                    (v4/*: any*/),
                                                    (v30/*: any*/),
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "concreteType": "FormFieldThemeOption",
                                                      "kind": "LinkedField",
                                                      "name": "children",
                                                      "plural": true,
                                                      "selections": [
                                                        (v4/*: any*/),
                                                        (v30/*: any*/),
                                                        (v2/*: any*/)
                                                      ],
                                                      "storageKey": null
                                                    },
                                                    (v2/*: any*/)
                                                  ],
                                                  "storageKey": null
                                                },
                                                (v2/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            (v2/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v2/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v2/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v2/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v2/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldThemes",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerThemes",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "none",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumEvents",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowNone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": "name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldEvents",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerEvents",
  "abstractKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consentGiven",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayEmailConsent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "consentLabel",
              "storageKey": null
            }
          ],
          "type": "FormFieldEmailWithConsents",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerEmailWithConsents",
  "abstractKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OralInterviewMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v17/*: any*/),
        (v15/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closingMessage",
              "storageKey": null
            }
          ],
          "type": "FormFieldOralInterview",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "individualSummary",
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minimumSelectableOptions",
              "storageKey": null
            },
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                (v37/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldSortableList",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerSortableList",
  "abstractKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerItemOption",
      "kind": "LinkedField",
      "name": "itemOptions",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldItem",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        (v9/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v28/*: any*/),
            (v27/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v31/*: any*/)
          ],
          "type": "FormFieldMatrix",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerMatrix",
  "abstractKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTitle",
  "abstractKey": null
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v13/*: any*/)
          ],
          "type": "FormFieldPresentationTextZone",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTextZone",
  "abstractKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "answers",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSeparator",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "formField",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FormFieldDisplayCondition",
            "kind": "LinkedField",
            "name": "displayConditions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formFieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormFieldDisplayConditionOption",
                "kind": "LinkedField",
                "name": "conditionOptions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "otherOption",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "displayConditionAnswers",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v29/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "formField",
            "plural": false,
            "selections": [
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "answers",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v12/*: any*/),
              (v6/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v29/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "AnswerAddress",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "formField",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "goal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxAmount",
                    "storageKey": null
                  }
                ],
                "type": "FormFieldBudget",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AnswerBudgetChapter",
            "kind": "LinkedField",
            "name": "answers",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "formField",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormFieldOptionBudgetLine",
                        "kind": "LinkedField",
                        "name": "budgetLines",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v1/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withOptions",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayMode",
                            "storageKey": null
                          },
                          (v28/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BudgetLineOption",
                            "kind": "LinkedField",
                            "name": "budgetLineOptions",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "position",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "FormFieldBudgetChapter",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "AnswerBudget",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthenticationManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuthenticationModal_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationConfig",
        "kind": "LinkedField",
        "name": "authenticationConfig",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuthenticationModal_authenticationConfig"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthenticationManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isViewer"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUser",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailConsent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailTrackingConsent",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationConfig",
        "kind": "LinkedField",
        "name": "authenticationConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowUserAccountCreation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationModalDisplay",
            "kind": "LinkedField",
            "name": "authenticationModal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayFranceConnect",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayOpenid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displaySaml",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displaySignIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displaySignUp",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SsoOpenidAuthenticationConfig",
            "kind": "LinkedField",
            "name": "franceConnectAuthServices",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SsoSamlAuthenticationConfig",
            "kind": "LinkedField",
            "name": "samlAuthServices",
            "plural": true,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SsoOpenidAuthenticationConfig",
            "kind": "LinkedField",
            "name": "openidAuthServices",
            "plural": true,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "forceEmailForAnonymousUsers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableEmailConsent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailConsentLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "anonymousUserSubscriptionFormResponse",
            "plural": false,
            "selections": (v42/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayCaptcha",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hcaptchaSiteKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "privacyPolicyPageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailConfirmationRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "userSubscriptionFormResponse",
            "plural": false,
            "selections": (v42/*: any*/),
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a1cb173f4e9e654c652a8a2f9e92277",
    "id": null,
    "metadata": {},
    "name": "AuthenticationManagerQuery",
    "operationKind": "query",
    "text": "query AuthenticationManagerQuery {\n  viewer {\n    __typename\n    ...AuthenticationModal_viewer\n    id\n  }\n  authenticationConfig {\n    ...AuthenticationModal_authenticationConfig\n    id\n  }\n}\n\nfragment AnswerAddress_answer on AnswerAddress {\n  formField {\n    __typename\n    id\n    fieldName\n    hide\n  }\n  answers {\n    __typename\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...ShallowAnswer_answer\n  }\n}\n\nfragment AnswerBudgetChapter_answer on AnswerBudgetChapter {\n  values\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudgetChapter {\n      budgetLines {\n        id\n        name\n        value\n        withOptions\n        displayMode\n        maximumSelectableOptions\n        description\n        budgetLineOptions {\n          id\n          label\n          value\n          position\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerBudgetDispatcher_answer on AnswerBudgetDispatcher {\n  id\n  dispatchedBudgetValues {\n    optionId\n    value\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldBudgetDispatcher {\n      budget\n      maxBudgetPerOption\n      minBudgetToSpend\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerBudget_answer on AnswerBudget {\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudget {\n      goal\n      unit\n      minAmount\n      maxAmount\n    }\n    id\n  }\n  answers {\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...AnswerBudgetChapter_answer\n  }\n}\n\nfragment AnswerCheckBoxes_answer on AnswerCheckBoxes {\n  values\n  other\n  otherValue\n  formField {\n    __typename\n    id\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldCheckBoxes {\n      displayOtherField\n      otherFieldLabel\n      singleOptionSelection\n      maximumSelectableOptions\n      selectableType\n      listedOptions {\n        id\n        name\n        isCorrect\n        correctionText\n      }\n    }\n  }\n  ...FormFieldOptionsSelect_answer\n}\n\nfragment AnswerEmailWithConsents_answer on AnswerEmailWithConsents {\n  id\n  content\n  consentGiven\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEmailWithConsents {\n      displayEmailConsent\n      consentLabel\n    }\n  }\n}\n\nfragment AnswerEvents_answer on AnswerEvents {\n  id\n  eventIds\n  none\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEvents {\n      maximumEvents\n      allowNone\n      options {\n        id\n        name: title\n      }\n    }\n  }\n}\n\nfragment AnswerFile_answer on AnswerFile {\n  sourcesAttachmentToken\n  sources {\n    key\n    name\n    url\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldFile {\n      multiple\n      maxFiles\n      allowedFileExtensions\n      maximumFileSize\n    }\n  }\n}\n\nfragment AnswerMatrix_answer on AnswerMatrix {\n  id\n  other\n  otherValue\n  itemOptions {\n    other\n    item {\n      id\n    }\n    option {\n      id\n    }\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldMatrix {\n      maximumSelectableOptions\n      singleOptionSelection\n      displayOtherField\n      otherFieldLabel\n      items {\n        id\n        label\n      }\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerOralInterview_answer on AnswerOralInterview {\n  content\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    fieldName\n    hide\n  }\n  ...InterviewChatSection_answer\n  ...InterviewCompletionSection_answer\n  ...InterviewControlsSection_answer\n  ...InterviewIntroSection_answer\n  ...InterviewResponseSection_answer\n}\n\nfragment AnswerPresentationTextZone_answer on AnswerPresentationTextZone {\n  formField {\n    __typename\n    ... on FormFieldPresentationTextZone {\n      content\n    }\n    id\n  }\n}\n\nfragment AnswerPresentationTitle_answer on AnswerPresentationTitle {\n  formField {\n    __typename\n    label\n    id\n  }\n}\n\nfragment AnswerRichText_answer on AnswerRichText {\n  id\n  content\n  contentAttachmentToken\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    id\n  }\n  ...SimilarAnswersSuggestions_answer\n}\n\nfragment AnswerSortableList_answer on AnswerSortableList {\n  id\n  values\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldSortableList {\n      minimumSelectableOptions\n      maximumSelectableOptions\n      options {\n        __typename\n        id\n        name\n        description\n      }\n    }\n  }\n}\n\nfragment AnswerString_answer on AnswerString {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldString {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerText_answer on AnswerText {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldText {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerThemes_answer on AnswerThemes {\n  selectedThemeIds\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldThemes {\n      maximumThemes\n      themes {\n        label\n        value\n        children {\n          label\n          value\n          children {\n            label\n            value\n            children {\n              label\n              value\n              children {\n                label\n                value\n                children {\n                  label\n                  value\n                  children {\n                    label\n                    value\n                    children {\n                      label\n                      value\n                      children {\n                        label\n                        value\n                        children {\n                          label\n                          value\n                          children {\n                            label\n                            value\n                            id\n                          }\n                          id\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment Answer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...ShallowAnswer_answer\n  ...AnswerAddress_answer\n  ...AnswerBudget_answer\n  ...useAnswerShouldBeConditionnallyHidden_answer\n}\n\nfragment Answers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  isSeparator\n  ...Answer_answer\n  ...useFilterConditionnallyHiddenAnswers_answers\n}\n\nfragment AuthenticationAnonymousUserForm_authenticationConfig on AuthenticationConfig {\n  forceEmailForAnonymousUsers\n  enableEmailConsent\n  emailConsentLabel\n  anonymousUserSubscriptionFormResponse {\n    answers {\n      __typename\n      ...Answers_answers\n      id\n    }\n    id\n  }\n}\n\nfragment AuthenticationCaptcha_authenticationConfig on AuthenticationConfig {\n  displayCaptcha\n  hcaptchaSiteKey\n}\n\nfragment AuthenticationFranceConnectForm_franceConnectAuth on SsoOpenidAuthenticationConfig {\n  signInUrl\n}\n\nfragment AuthenticationModalMethods_authenticationConfig on AuthenticationConfig {\n  authenticationModal {\n    displayOpenid\n    displaySaml\n    displaySignIn\n    displaySignUp\n  }\n  samlAuthServices {\n    id\n    ...AuthenticationSamlForm_samlAuth\n  }\n  openidAuthServices {\n    id\n    ...AuthenticationOpenidForm_openidAuth\n  }\n  ...AuthenticationAnonymousUserForm_authenticationConfig\n  ...AuthenticationSignIn_authenticationConfig\n  ...AuthenticationSignUp_authenticationConfig\n}\n\nfragment AuthenticationModal_authenticationConfig on AuthenticationConfig {\n  allowUserAccountCreation\n  authenticationModal {\n    displayed\n    displayFranceConnect\n    displayOpenid\n    displaySaml\n    displaySignIn\n    displaySignUp\n  }\n  franceConnectAuthServices {\n    id\n    ...AuthenticationFranceConnectForm_franceConnectAuth\n  }\n  ...AuthenticationModalMethods_authenticationConfig\n}\n\nfragment AuthenticationModal_viewer on Viewer {\n  __isViewer: __typename\n  isUser\n  name\n  email\n  emailConsent\n  emailTrackingConsent\n}\n\nfragment AuthenticationOpenidForm_openidAuth on SsoOpenidAuthenticationConfig {\n  label\n  signInUrl\n}\n\nfragment AuthenticationSamlForm_samlAuth on SsoSamlAuthenticationConfig {\n  label\n  signInUrl\n}\n\nfragment AuthenticationSignIn_authenticationConfig on AuthenticationConfig {\n  allowUserAccountCreation\n  ...AuthenticationCaptcha_authenticationConfig\n}\n\nfragment AuthenticationSignUp_authenticationConfig on AuthenticationConfig {\n  privacyPolicyPageUrl\n  emailConfirmationRequired\n  enableEmailConsent\n  emailConsentLabel\n  userSubscriptionFormResponse {\n    answers {\n      __typename\n      ...Answers_answers\n      id\n    }\n    id\n  }\n}\n\nfragment FormFieldOptionsSelect_answer on AnswerCheckBoxes {\n  selectedOptions {\n    id\n    name\n  }\n  formField {\n    __typename\n    id\n    ... on FormFieldCheckBoxes {\n      optionsSearchable\n    }\n  }\n}\n\nfragment InterviewChatMessage_message on OralInterviewMessage {\n  role\n  text\n}\n\nfragment InterviewChatSection_answer on AnswerOralInterview {\n  messages {\n    ...InterviewChatMessage_message\n  }\n}\n\nfragment InterviewCompletionSection_answer on AnswerOralInterview {\n  individualSummary\n  formField {\n    __typename\n    ... on FormFieldOralInterview {\n      closingMessage\n    }\n    id\n  }\n}\n\nfragment InterviewControlsSection_answer on AnswerOralInterview {\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    required\n  }\n}\n\nfragment InterviewIntroSection_answer on AnswerOralInterview {\n  formField {\n    __typename\n    hint\n    id\n  }\n}\n\nfragment InterviewResponseSection_answer on AnswerOralInterview {\n  status\n  formField {\n    __typename\n    id\n  }\n}\n\nfragment ShallowAnswer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...AnswerString_answer\n  ...AnswerText_answer\n  ...AnswerRichText_answer\n  ...AnswerFile_answer\n  ...AnswerCheckBoxes_answer\n  ...AnswerBudgetDispatcher_answer\n  ...AnswerThemes_answer\n  ...AnswerEvents_answer\n  ...AnswerEmailWithConsents_answer\n  ...AnswerOralInterview_answer\n  ...AnswerSortableList_answer\n  ...AnswerMatrix_answer\n  ...AnswerPresentationTitle_answer\n  ...AnswerPresentationTextZone_answer\n}\n\nfragment SimilarAnswersSuggestions_answer on AnswerRichText {\n  ...useSimilarAnswers_answer\n}\n\nfragment useAnswerShouldBeConditionnallyHidden_answer on AnswerBase {\n  __isAnswerBase: __typename\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useFilterConditionnallyHiddenAnswers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useSimilarAnswers_answer on AnswerRichText {\n  id\n  formField {\n    __typename\n    id\n    authorizations {\n      displaySimilarContributionsSuggestions\n    }\n  }\n}\n"
  }
};
})();

node.hash = "91e1aeefcd8a2320be62f01f1ba7fe9a";

module.exports = node;
